import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import { routerBeforeEach } from '@conf'

//处理 重复点击 路由报错
const originalReplace = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalReplace.call(this, location).catch(err => err)
}
Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  base: window.__POWERED_BY_QIANKUN__ ? '/app/dataCenter' : '/',
  routes
})

// 注入拦截
router.beforeEach(routerBeforeEach)

export default router
